export const VISITS_FROM_COUNTRY_LOCAL_STORAGE_KEY = "si:advanced-search:visits-from";
